import React from 'react';
import styled from 'styled-components';
import { usePWA } from '../../hooks/usePWA';

const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null;
  }

  return (
    <OfflineContainer>
      <OfflineContent>
        <OfflineIcon>📡</OfflineIcon>
        <OfflineText>
          <OfflineTitle>You're offline</OfflineTitle>
          <OfflineDescription>
            Some features may be limited. We'll sync your changes when you're back online.
          </OfflineDescription>
        </OfflineText>
      </OfflineContent>
    </OfflineContainer>
  );
};

const OfflineContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.status.warning};
  color: white;
  z-index: 1002;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

const OfflineContent = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  gap: 12px;
  max-width: 1200px;
  margin: 0 auto;
`;

const OfflineIcon = styled.div`
  font-size: 20px;
  flex-shrink: 0;
`;

const OfflineText = styled.div`
  flex: 1;
  min-width: 0;
`;

const OfflineTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px;
`;

const OfflineDescription = styled.span`
  font-size: 14px;
  opacity: 0.9;

  @media (max-width: 768px) {
    display: none;
  }
`;

export default OfflineIndicator;